// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"53322825","707":"eec75b71"}[chunkId] + ".chunk.js";
};